(function () {
	function initTableDrag() {
		const sliders = document.querySelectorAll('.premium-aplus-module-5 .table-slider');
		
		sliders.forEach((slider) => {
			if (slider.dataset.dragInitialized === 'true') return;
			slider.dataset.dragInitialized = 'true';
			
			let isMouseDown = false;
			let isDragging = false;
			let startX = 0;
			let scrollLeft = 0;
			let preventClick = false;
			let rafId = null;
			let pendingScroll = 0;

			function onDragMove(e) {
				if (!isMouseDown) return;

				const moved = e.pageX - startX;

				if (Math.abs(moved) > 6) {
					isDragging = true;
					preventClick = true;
					slider.classList.add('is-dragging');
				}

				if (!isDragging) return;

				e.preventDefault();
				pendingScroll = scrollLeft - moved;

				if (rafId) return;
				rafId = requestAnimationFrame(function () {
					rafId = null;
					slider.scrollLeft = pendingScroll;
				});
			}

			function stopDrag() {
				if (!isMouseDown) return;

				isMouseDown = false;
				document.removeEventListener('mousemove', onDragMove);
				document.removeEventListener('mouseup', stopDrag);

				if (rafId) {
					cancelAnimationFrame(rafId);
					rafId = null;
				}

				slider.classList.remove('is-dragging');

				setTimeout(function () {
					preventClick = false;
				}, 0);
			}

			slider.addEventListener('mousedown', function (e) {
				if (window.innerWidth <= 768) return;
				if (e.button !== 0) return;

				isMouseDown = true;
				isDragging = false;
				startX = e.pageX;
				scrollLeft = slider.scrollLeft;

				document.addEventListener('mousemove', onDragMove);
				document.addEventListener('mouseup', stopDrag);
			});

			slider.addEventListener('mouseleave', stopDrag);
				
				slider.addEventListener(
					'click',
					function (e) {
						if (!preventClick) return;
						e.preventDefault();
						e.stopPropagation();
					},
					true
				);
				
				slider.addEventListener('dragstart', function (e) {
					e.preventDefault();
				});
			});
		}
		
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', initTableDrag);
		} else {
			initTableDrag();
		}
		
		document.addEventListener('shopify:section:load', initTableDrag);
	})();
